import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'

import { LOCALE_PREFIX } from './constants'

import hocConnect from './hocConnect'

import './style.scss'

@hocConnect
export default class ImportPreloader extends Component {
    static propTypes = {
        groupName: PropTypes.string.isRequired,
    }

    render() {
        const { groupName } = this.props

        return (
            <div className={'import-preload-wrap'}>
                <FormattedMessage id={`${LOCALE_PREFIX}.importing`} />
                <span>{groupName}</span>
                <div className={'import-preloader'} />
            </div>
        )
    }
}
